module.exports = __webpack_public_path__ + "static/media/drop.19448308.svg";